<template>
  <div>
    <wc-page-title title='Sold'>
      <template v-slot:rightSide>
        <wc-toolbar-search v-model='search'></wc-toolbar-search>
      </template>
    </wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box hideToolbar>
            <estimates-table
              :isLoading='isLoading'
              :estimates='filteredEstimates'
              :search='search'
            ></estimates-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import _ from 'lodash'
import formRules from '@/mixins/formRules'
import estimatesAPI from '@/modules/estimates/api/estimates'
import EstimatesTable from '../components/EstimatesTable'

export default {
  name: 'sold-estimates',
  mixins: [formRules],
  data: () => ({
    isLoading: false,
    search: '',
    estimates: [],
    division: {},
    showArchived: false,
  }),
  computed: {
    divisions () {
      return this.$store.state.misc.divisions
    },
    filteredEstimates () {
      return _.orderBy(this.estimates, ['estimate_date', 'name'], ['desc','asc'])
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.estimates = await estimatesAPI.getSoldEstimates()
      this.isLoading = false
    },
    openEstimate (est) {
      this.$router.push({ name: est.division_obj.division + 'Estimate', params: { id: est.id } })
    }
  },
  components: {
    'estimates-table': EstimatesTable
  }
}
</script>
